"use strict";

exports.__esModule = true;
exports.default = void 0;
var svgCache = {};
var _default = svgCache;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tanem/svg-injector/lib/svg-cache.js
// module id = 113
// module chunks = 0